// extracted by mini-css-extract-plugin
export default {"row":"row--RqZVO"};